import iris from '../api/iris';
import BaseFetch from './base';

export default class Iris extends BaseFetch {
    api = iris
}
